import { z } from 'zod';

// prettier-ignore
export const CountryCodeZod = z.enum([
    'AZ', 'AZ', 'NF', 'PW', 'HN',
    'CY', 'GI', 'AI', 'LC', 'UG',
    'LS', 'FM', 'PS', 'LI', 'MA',
    'KI', 'TM', 'MO', 'MM', 'TZ',
    'CR', 'LV', 'CW', 'MX', 'ME',
    'PY', 'TF', 'ID', 'IR', 'SY',
    'BF', 'BM', 'VU', 'GH', 'JP',
    'TH', 'CX', 'GU', 'GP', 'NI',
    'NP', 'CN', 'BG', 'MR', 'AR',
    'PG', 'BQ', 'IE', 'EE', 'ZW',
    'UY', 'RU', 'CG', 'TR', 'BO',
    'QA', 'MP', 'GM', 'BB', 'AW',
    'GQ', 'ST', 'SX', 'LA', 'DJ',
    'AO', 'KN', 'EH', 'BT', 'GT',
    'TN', 'AS', 'TL', 'CF', 'SD',
    'BS', 'LR', 'TO', 'IM', 'PH',
    'BY', 'AX', 'MC', 'SR', 'UM',
    'PF', 'AQ', 'LB', 'EG', 'TJ',
    'MU', 'SO', 'VC', 'NU', 'SC',
    'GD', 'AL', 'HR', 'GG', 'ML',
    'SN', 'PK', 'SJ', 'BJ', 'KY',
    'SS', 'EC', 'BN', 'MV', 'BA',
    'CK', 'FI', 'IO', 'MH', 'TK',
    'NZ', 'NE', 'KZ', 'ES', 'KW',
    'BI', 'HM', 'FK', 'GF', 'BD',
    'PR', 'UZ', 'TC', 'MS', 'IS',
    'GW', 'TG', 'KG', 'MG', 'WS',
    'NL', 'CD', 'BV', 'GR', 'PA',
    'SZ', 'FO', 'VI', 'TW', 'MW',
    'JO', 'PL', 'GA', 'TT', 'DE',
    'KP', 'CV', 'KR', 'GS', 'DO',
    'WF', 'TD', 'SG', 'CH', 'HK',
    'BZ', 'RO', 'AD', 'ZM', 'IL',
    'BL', 'DK', 'PN', 'GB', 'VA',
    'TV', 'SL', 'BE', 'HT', 'MN',
    'VE', 'CC', 'GN', 'IT', 'CU',
    'VG', 'HU', 'FR', 'CO', 'SA',
    'CZ', 'UA', 'US', 'DZ', 'MF',
    'ZA', 'JM', 'SI', 'DM', 'PT',
    'NA', 'GE', 'NR', 'RE', 'PM',
    'KE', 'NC', 'GL', 'MQ', 'AE',
    'PE', 'MZ', 'NG', 'LY', 'CA',
    'MY', 'SB', 'KM', 'MT', 'ET',
    'AM', 'FJ', 'VN', 'SM', 'JE',
    'NO', 'OM', 'KH', 'SV', 'AU',
    'AF', 'SH', 'YT', 'ER', 'RS',
    'BR', 'LK', 'RW', 'YE', 'BH',
    'GY', 'SE', 'LU', 'SK', 'IQ',
    'AG', 'MD', 'CM', 'MK', 'IN',
    'CL', 'CI', 'LT', 'BW', 'AT',
    'XK',
]);

export type CountryCodeType = z.TypeOf<typeof CountryCodeZod>;

export const isCountryCodeType = (data: unknown): data is CountryCodeType => {
    const result = CountryCodeZod.safeParse(data);
    return result.success;
};

export type CountryNameType = Record<CountryCodeType, string>;
// prettier-ignore
export const countryName: CountryNameType = {
    GB: 'United Kingdom',
    IE: 'Ireland',
    AL: 'Albania',
    AD: 'Andorre',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AT: 'Austria',
    AW: 'Aruba',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BB: 'Barbade',
    BY: 'Belarus',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    IO: 'British Indian Ocean Territory',
    VG: 'British Virgin Islands',
    BN: 'Brunei',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CL: 'Chile',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo (Dem. Rep.)',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    ME: 'Crna Gora',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CI: 'Côte D\'Ivoire',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    TL: 'East Timor',
    EG: 'Egypt',
    SV: 'El Salvador',
    ER: 'Eritrea',
    EE: 'Estonia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GD: 'Grenada',
    GT: 'Guatemala',
    GG: 'Guernsey and Alderney',
    GN: 'Guinea',
    GY: 'Guyana',
    HM: 'Heard and McDonald Islands',
    HN: 'Honduras',
    IS: 'Iceland',
    IQ: 'Iraq',
    IM: 'Isle of Man',
    IT: 'Italy',
    JM: 'Jamaica',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MU: 'Mauritius',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands Antilles',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NO: 'Norway',
    OM: 'Oman',
    PW: 'Palau',
    PS: 'Palestine',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PN: 'Pitcairn',
    QA: 'Qatar',
    RO: 'Romania',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SX: 'Sint Maarten',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    ST: 'São Tomé and Príncipe',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VA: 'Vatican City',
    VE: 'Wenezuela',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AX: 'Åland Island',
    XK: 'Kosovo',
    NF: 'Norfolk Island',
    CY: 'Cyprus',
    TM: 'Turkmenistan',
    MM: 'Myanmar',
    LV: 'Latvia',
    TF: 'French Southern Territories',
    ID: 'Indonesia',
    IR: 'Iran',
    SY: 'Syrian Arab Republic',
    JP: 'Japan',
    CX: 'Christmas Island',
    GU: 'Guam',
    GP: 'Guadeloupe',
    CN: 'China',
    ZW: 'Zimbabwe',
    RU: 'Russian Federation',
    TR: 'Turkey',
    MP: 'Northern Mariana Islands',
    GQ: 'Equatorial Guinea',
    DJ: 'Djibouti',
    AO: 'Angola',
    AS: 'American Samoa',
    CF: 'Central African Republic',
    SD: 'Sudan',
    PH: 'Philippines',
    UM: 'United States Minor Outlying Islands',
    PF: 'French Polynesia',
    SO: 'Somalia',
    ML: 'Mali',
    PK: 'Pakistan',
    SS: 'South Sudan',
    EC: 'Ecuador',
    FI: 'Finland',
    GF: 'French Guiana',
    BD: 'Bangladesh',
    PR: 'Puerto Rico',
    UZ: 'Uzbekistan',
    GW: 'Guinea-Bissau',
    GR: 'Greece',
    VI: 'Virgin Islands (U.S.)',
    PL: 'Poland',
    DE: 'Germany',
    KP: 'Korea (Democratic People\'s Republic of)',
    KR: 'Korea, Republic of',
    WF: 'Wallis and Futuna',
    TD: 'Chad',
    SG: 'Singapore',
    CH: 'Switzerland',
    HK: 'Hong Kong',
    BZ: 'Belize',
    IL: 'Israel',
    DK: 'Denmark',
    BE: 'Belgium',
    HT: 'Haiti',
    CC: 'Cocos (Keeling) Islands',
    HU: 'Hungary',
    FR: 'France',
    CZ: 'Czechia',
    UA: 'Ukraine',
    US: 'United States of America',
    DZ: 'Algeria',
    PT: 'Portugal',
    RE: 'Réunion',
    PM: 'Saint Pierre and Miquelon',
    NC: 'New Caledonia',
    GL: 'Greenland',
    MQ: 'Martinique',
    AE: 'United Arab Emirates',
    LY: 'Libya',
    CA: 'Canada',
    MY: 'Malaysia',
    ET: 'Ethiopia',
    VN: 'Viet Nam',
    KH: 'Cambodia',
    AU: 'Australia',
    AF: 'Afghanistan',
    YT: 'Mayotte',
    RS: 'Serbia',
    BR: 'Brazil',
    RW: 'Rwanda',
    YE: 'Yemen',
    SK: 'Slovakia',
    IN: 'India',
};

export type CountryEntryType = { id: CountryCodeType; name: string };
export type CountriesType = Array<CountryEntryType>;

export const countries = Object.entries(countryName).reduce<CountriesType>((prev, [id, name]) => {
    if (isCountryCodeType(id)) {
        return [...prev, { id, name }];
    }
    return prev;
}, []);
